import { InlineStack, SkeletonBodyText, SkeletonDisplayText } from '@shopify/polaris';
import { Table } from 'antd';
import React from 'react';

const TransferOrderSkeleton = () => {
    const columns = [
        {
            title: 'Product Title',
            dataIndex: 'title',
            key: 'title',
            width: '300px',
        },
        {
            title: 'SKU',
            dataIndex: 'sku',
            key: 'sku',
            width: '150px',
        },
        {
            title: 'ASIN',
            dataIndex: 'ASIN',
            key: 'ASIN',
            width: '150px',

        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            width: '100px',
        },
    ];
    const rows = [
        {
            key: '1',
            title: <SkeletonBodyText lines={3} />,
            sku: <SkeletonBodyText lines={1} />,
            ASIN: <SkeletonBodyText lines={1} />,
            action: <SkeletonDisplayText size="medium" />,
        },
        {
            key: '2',
            title: <SkeletonBodyText lines={3} />,
            sku: <SkeletonBodyText lines={1} />,
            ASIN: <SkeletonBodyText lines={1} />,
            action: <SkeletonDisplayText size="medium" />,
        },
    ];
    return (
        <Table
            pagination={false}
            size='middle'
            dataSource={rows}
            columns={columns}
            scroll={{ x: 600 }}
            footer={() => <InlineStack align="space-between" wrap={false} gap="200" blockAlign='center'>
                <div className='Custom-Stack-Item--fill'>
                    <SkeletonBodyText lines={1} />
                </div>
                <div className='custom-skeleton-btn'>
                    <SkeletonDisplayText size="medium" />
                </div>
            </InlineStack>}
        />
    );
}


export default TransferOrderSkeleton;